module.exports = __webpack_public_path__ + "static/img/20.8c2aaaa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20.png
// module id = jMQT
// module chunks = 1